// extracted by mini-css-extract-plugin
export default {"paper":"OnlineOrderButton_paper__a3uTZ","platformCard":"OnlineOrderButton_platformCard__rPFLa","platformCardSelected":"OnlineOrderButton_platformCardSelected__dXmnj"};